import { Injectable } from '@angular/core';
import { DottedKey } from '../../record/entities/metadata-field.entity';
import { ColumnHandlerService } from '../../record/services/column-handler.service';
import { Task } from '../entities/task.entity';
import { ApiFragment } from '../../record/entities/api-fragment.entity';
import { TaskDeadlineCellComponent } from '../components/cells/task-deadline-cell/task-deadline-cell.component';
import { TaskTypeCellComponent } from '../components/cells/task-type-cell/task-type-cell.component';

@Injectable()
export class TaskColumnHandlerService extends ColumnHandlerService<Task | ApiFragment> {
    constructor() {
        super();
        this.setTaskDefaults();
    }

    private setTaskDefaults(): void {
        this.components.set(DottedKey.TasksTaskTypeName, TaskTypeCellComponent);
        this.components.set(DottedKey.TasksTaskDueDate, TaskDeadlineCellComponent);
    }
}
